var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current_plan"},_vm._l((_vm.textPlan),function(item,index){return _c('p',{key:index,staticClass:"plan_p"},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }